export type BannedNumbers = {
	bannedNumbers: number[];
};

const model: types.models.InputModel = {
	bannedNumbers: ['response.bannedNumbers', []],
};

export default model;
